// config/prod.env.js
export const NODE_ENV = "production";
export const API_BASE_URL = "https://api.smallschoolbag.com/";



// WEBPACK FOOTER //
// ./src/configPort/production.env.js